import '../../../../../../motion-utils/dist/es/errors.mjs';
import { velocityPerSecond } from '../../../../../../motion-utils/dist/es/velocity-per-second.mjs';

const velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - velocitySampleDuration, 0);
    return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

export { calcGeneratorVelocity };
